const validatePayingCustomerCookie = {
    init() {
        /*
        Test Cookie: For development purpose and only for www.bexio.test and not for www.bexio.com
        document.cookie = "gtmcustomertype=trial; expires=Thu, 11 Jan 2024 12:00:00 UTC; path=/";
        document.cookie = "gtmcustomertype=paying; expires=Thu, 11 Jan 2024 12:00:00 UTC; path=/";
         */
        const gtmPayingCustomerCookieValue = window.helpers.getCookie('gtmcustomertype');
        let hideLightbox, showAdBar;

        const advertisingPromo = document.getElementsByClassName("advertising-promotion");
        if (advertisingPromo.length){
            const isBannerForPayingCustomers = advertisingPromo[0].classList.contains('paying-customers');
            const isBannerForNonPayingCustomers = advertisingPromo[0].classList.contains('non-paying-customers');

            /*
            The banner should be shown if:
            1. The user is not a paying customer, or the banner is not specifically for non-paying customers.
            2. The user is a paying customer, or the banner is not specifically for paying customers.

            In other words, the advertisement banner will be shown unless:
            - The user is a paying customer and the banner is only for non-paying customers, or
            - The user is not a paying customer and the banner is only for paying customers.
            */

            if (gtmPayingCustomerCookieValue === 'paying' && isBannerForNonPayingCustomers){
                showAdBar = false;
            } else if (gtmPayingCustomerCookieValue !== 'paying' && isBannerForPayingCustomers){
                showAdBar = false;
            } else {
                showAdBar = true;
            }
        }

        const lightboxPromo =  document.getElementsByClassName("advertising-lightbox-promotion");
        if (lightboxPromo.length) {
            const isLightboxForPayingCustomers = lightboxPromo[0].classList.contains('paying-customers');
            const isLightboxForNonPayingCustomers = lightboxPromo[0].classList.contains('non-paying-customers');

            if (gtmPayingCustomerCookieValue === 'paying' && isLightboxForNonPayingCustomers){
                hideLightbox = true;
            } else if (gtmPayingCustomerCookieValue !== 'paying' && isLightboxForPayingCustomers){
                hideLightbox = true;
            } else {
                hideLightbox = false;
            }
        }

        if (showAdBar) {
            this.displayPromotion();
        }

        if(hideLightbox){
            this.hidePromotionLightbox();
        }
    },
    hidePromotionLightbox(){
        // variable used in "src/global/js/alpine/promotionLightbox.js"
        window.hideLightboxPromotion = true;
    },
    displayPromotion(){
        // Add "hidden" class to elements with data-type="regular"
        document.querySelectorAll('[data-promo-type="regular"]').forEach(function(element) {
            element.classList.add('hidden');
        });

        // Remove "hidden" class from elements with data-type="promotion"
        document.querySelectorAll('[data-promo-type="discount"]').forEach(function(element) {
            element.classList.remove('hidden');
        });
    },
};

validatePayingCustomerCookie.init();
